(function(){
"use strict";
var rm=window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function reveal(){
  var items=[].slice.call(document.querySelectorAll(".kk-rv:not(.is-in)"));
  if(!items.length)return;
  if(rm||!("IntersectionObserver" in window)){items.forEach(function(n){n.classList.add("is-in")});return}
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("is-in");io.unobserve(e.target)}})
  },{threshold:.08,rootMargin:"0px 0px -6% 0px"});
  items.forEach(function(n,i){n.style.transitionDelay=Math.min(i%6*60,300)+"ms";io.observe(n)});
}

function sticky(){
  var bar=document.querySelector("[data-kk-sticky]");
  var hero=document.querySelector("[data-kk-hero]");
  if(!bar||!hero)return;
  document.body.classList.add("kk-has-sticky");
  var dates=document.getElementById("termine");
  var ticking=false,shown=false;
  function run(){
    ticking=false;
    var r=hero.getBoundingClientRect();
    var on=r.bottom<window.innerHeight*.35;
    if(dates){
      var d=dates.getBoundingClientRect();
      if(d.top<window.innerHeight*.6&&d.bottom>window.innerHeight*.6)on=false;
    }
    if(on!==shown){shown=on;bar.classList.toggle("is-on",on);bar.setAttribute("aria-hidden",on?"false":"true");var a=bar.querySelector("a");if(a)a.tabIndex=on?0:-1}
  }
  window.addEventListener("scroll",function(){if(!ticking){ticking=true;requestAnimationFrame(run)}},{passive:true});
  window.addEventListener("resize",run,{passive:true});
  run();
}

function anchors(){
  document.addEventListener("click",function(e){
    var a=e.target.closest?e.target.closest('a[href^="#"]:not([href="#"])'):null;
    if(!a)return;
    var t=null;
    try{t=document.querySelector(a.getAttribute("href"))}catch(err){return}
    if(!t)return;
    e.preventDefault();
    t.scrollIntoView({behavior:rm?"auto":"smooth",block:"start"});
    if(history.replaceState)history.replaceState(null,"",a.getAttribute("href"));
  });
}

function countdown(){
  var els=[].slice.call(document.querySelectorAll("[data-kk-countdown]"));
  if(!els.length)return;
  function pad(n){return (n<10?"0":"")+n}
  function tick(){
    var now=Date.now();
    els.forEach(function(el){
      var t=Date.parse(el.getAttribute("data-kk-countdown"));
      if(isNaN(t))return;
      var d=t-now;
      if(d<=0){el.classList.add("is-over");return}
      var s=Math.floor(d/1000);
      var set=function(k,v){var n=el.querySelector('[data-cd="'+k+'"]');if(n&&n.textContent!==v)n.textContent=v};
      set("d",String(Math.floor(s/86400)));set("h",pad(Math.floor(s%86400/3600)));set("m",pad(Math.floor(s%3600/60)));set("s",pad(s%60));
    });
  }
  tick();
  if(!window.__kkCd)window.__kkCd=setInterval(tick,1000);
}

function init(){countdown();reveal();sticky();if(!document.body.classList.contains("template-index"))anchors()}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",init)}else{init()}
document.addEventListener("shopify:section:load",function(){reveal();sticky();countdown()});
})();
